class TabController {
  constructor() {
  }
}

export default TabController;



// WEBPACK FOOTER //
// ./src/components/tab/tab.controller.js